import { render, staticRenderFns } from "./Honey.vue?vue&type=template&id=6f44ff5d&scoped=true&"
import script from "./Honey.vue?vue&type=script&lang=js&"
export * from "./Honey.vue?vue&type=script&lang=js&"
import style0 from "./Honey.vue?vue&type=style&index=0&id=6f44ff5d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f44ff5d",
  null
  
)

export default component.exports